import { Map as MapIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useUscgMapContext } from '../LayersTab/UscgMapContext';
import { openMapItemPopup } from '../LayersTab/utils/openMapItemPopup';
import { IncidentPopupContent } from './IncidentPopupContent';
import type { IncidentListItemData } from './IncidentListItem';

interface IncidentMapButtonProps {
  incident: IncidentListItemData;
}

export function IncidentMapButton({ incident }: IncidentMapButtonProps) {
  const { mapView } = useUscgMapContext();

  return (
    <Button
      type="button"
      size="icon-sm"
      variant="ghost"
      title="Focus incident on map"
      aria-label={`Focus ${incident.name} on map`}
      onClick={(click) => {
        click.stopPropagation();
        if (!mapView || !incident.latLong) return;
        void openMapItemPopup({
          mapView,
          longitude: incident.latLong.longitude,
          latitude: incident.latLong.latitude,
          title: incident.name,
          zoom: 7,
          content: <IncidentPopupContent incident={incident} />,
        });
      }}
    >
      <MapIcon className="tw:h-4 tw:w-4" />
    </Button>
  );
}
